module.exports = __webpack_public_path__ + "media/application/images/2023/Headline XL-621aa3cb0fa72266e584abb1c6f1ac77.png";